import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function ChatBubbleIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 16 16" htmlColor={Color.Gray} {...props}>
      <path d="M4.23482 12.6817L2.97046 13.8403C2.7907 14.005 2.58402 14.0423 2.35042 13.9522C2.11681 13.862 2 13.6997 2 13.4652V5.04626C2 4.7539 2.11053 4.50643 2.33158 4.30386C2.55263 4.10129 2.82268 4 3.14171 4H12.8583C13.1773 4 13.4474 4.10129 13.6684 4.30386C13.8895 4.50643 14 4.7539 14 5.04626V11.6354C14 11.9278 13.8895 12.1752 13.6684 12.3778C13.4474 12.5804 13.1773 12.6817 12.8583 12.6817H4.23482Z" />
    </MuiSvgIcon>
  );
}
export default ChatBubbleIcon;
